import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-670528d0")

_pushScopeId("data-v-670528d0")
const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end","margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-refresh" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 刷新 ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "scrollable-area"
}
const _hoisted_10 = {
  key: 0,
  class: "mt20 mb30"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold","font-size":"16px"} }, "关联会话:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { style: {"margin-bottom":"10px"} }, [
  /*#__PURE__*/_createVNode("span", { style: {"font-weight":"bold","font-size":"16px"} }, "交管会话列表:")
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_c_table = _resolveComponent("c-table")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = $event)),
    width: "1000px",
    "before-close": _ctx.onCancel
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _ctx.init,
          loading: _ctx.tableConfig1.loading
        }, {
          default: _withId(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _createVNode(_component_el_form, {
        "label-width": "100px",
        "label-position": "right"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "企业名称:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.companyName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "名称:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "客户端ID:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.deviceNo), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "设备类型:" }, {
                    default: _withId(() => [
                      (_ctx.formdata.deviceType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_4, "物理设备"))
                        : _createCommentVNode("", true),
                      (_ctx.formdata.deviceType === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_5, "虚拟设备"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "省份:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.province), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "ip地址:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.ipAddress), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "心跳时间:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.lastHeartbeat), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "ota心跳时间:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.lastOtaHeartbeat), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "最大会话数:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.maxSessionCount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "活跃会话数:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.sessionCount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "状态:" }, {
                    default: _withId(() => [
                      (_ctx.formdata.status === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_6, "正常"))
                        : _createCommentVNode("", true),
                      (_ctx.formdata.status === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, "禁用"))
                        : _createCommentVNode("", true),
                      (_ctx.formdata.status === 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_8, "报废"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "创建时间:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.createTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 22 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "ota心跳信息:" }, {
                    default: _withId(() => [
                      (_ctx.formdata.heartbeatMsg)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode("pre", null, _toDisplayString(_ctx.formatJsonString(_ctx.formdata.heartbeatMsg)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 20 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "备注:" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.formdata.remark), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isSaasSession)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "mt40 mb40"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createTextVNode(" 企业名称: " + _toDisplayString(_ctx.formdata.saasSession.companyName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createTextVNode(" 账号: " + _toDisplayString(_ctx.formdata.saasSession.userName), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_12,
      _createVNode(_component_c_table, {
        class: "mt20",
        dataSource: _ctx.tableConfig1
      }, {
        accreditStatus: _withId((scope) => [
          (scope.row.accreditStatus === 0)
            ? (_openBlock(), _createBlock("span", _hoisted_13, "待授权"))
            : _createCommentVNode("", true),
          (scope.row.accreditStatus === 1)
            ? (_openBlock(), _createBlock("span", _hoisted_14, "正在授权"))
            : _createCommentVNode("", true),
          (scope.row.accreditStatus === 2)
            ? (_openBlock(), _createBlock("span", _hoisted_15, "已授权"))
            : _createCommentVNode("", true),
          (scope.row.accreditStatus === 3)
            ? (_openBlock(), _createBlock("span", _hoisted_16, "正在取消"))
            : _createCommentVNode("", true),
          (scope.row.accreditStatus === 4)
            ? (_openBlock(), _createBlock("span", _hoisted_17, "已取消"))
            : _createCommentVNode("", true)
        ]),
        active: _withId((scope) => [
          (scope.row.active === true)
            ? (_openBlock(), _createBlock("span", _hoisted_18, "是"))
            : _createCommentVNode("", true),
          (scope.row.active === false)
            ? (_openBlock(), _createBlock("span", _hoisted_19, "否"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})